import React, { useState, useEffect } from 'react'
import style from './questionCard.module.css';
import Correct from '../../assets/check.svg';
import Incorrect from '../../assets/x.svg';
import CorrectSound from '../../assets/audio/correctSound.mp3'
import WrongSound from '../../assets/audio/wrongSound.mp3'

const QuestionCard = ({ index, text, onClick, isCorrect, showCorrectAnswer, disabled}) => {

    const [optionStyle, setOptionStyle] = useState(style.option);
    const [displayImage, setDisplayImage] = useState();

    const [letter, setLetter] = useState('')

    const correctAudio = new Audio(CorrectSound);
    const wrongAudio = new Audio(WrongSound);

    useEffect(() => {
        switch (index) {
            case index = 0:
                setLetter('A')
                break;
            case index = 1:
                setLetter('B')
                break;
            case index = 2:
                setLetter('C')
                break;
            default:
                break;
        }
    }, [])

    const Show = () => {
        if(isCorrect) {
            setOptionStyle(style.correctOption)
            setDisplayImage(Correct);
        } else {
            setOptionStyle(style.incorrectOption)
            setDisplayImage(Incorrect);
        }
    }

    useEffect(() => {
        if (isCorrect && showCorrectAnswer) {
            setOptionStyle(style.correctOption)
            setDisplayImage(Correct);
        }
        if (!showCorrectAnswer) {
            setOptionStyle(style.option)
            setDisplayImage(undefined)
        } 
    }, [showCorrectAnswer]);

    const clickOrShow = () => {
        Show()
        onClick()
        if (isCorrect) {
            correctAudio.play();
        } else {
            wrongAudio.play();
        }
    }

    return (
        <div className={style.container}>
            <img src={displayImage ? displayImage : ''} className={style.image} alt={displayImage} />
            <p className={style.imageTest}>{letter}</p>
            <button className={optionStyle} onClick={ disabled ? undefined : clickOrShow } >
                {text}
            </button>
        </div>
    )
}

export default QuestionCard